import { createAction, props } from '@ngrx/store';

import { KpiSetDetails } from 'app/shared/report-model';

import { ReportEditionDetailsUserActionTypes } from '../models';

export const openReportEdition = createAction(
    ReportEditionDetailsUserActionTypes.openReportEdition,
    props<{ reportId: string; reportEditionId: string }>(),
);

export const openKpiSetDetails = createAction(
    ReportEditionDetailsUserActionTypes.openKpiSetDetails,
    props<{ kpiSetDetails: KpiSetDetails }>(),
);

export const reloadKpiSetDetails = createAction(
    ReportEditionDetailsUserActionTypes.reloadKpiSetDetails,
    props<{ kpiSetDetails: KpiSetDetails }>(),
);

export const reloadReportEdition = createAction(ReportEditionDetailsUserActionTypes.reloadReportEdition);

export const regenerateEdition = createAction(ReportEditionDetailsUserActionTypes.regenerateEdition);
